// Cloudflare Turnstile — replaces reCAPTCHA Enterprise.
// Widget type in the Cloudflare dashboard: "Managed". On submit the widget
// renders into the container the form provides (usually auto-passes in under
// a second; occasionally asks the user for an interactive check).
const SITE_KEY = "0x4AAAAAABiDYqWGI3Vqx3Fj";

function waitForTurnstile(timeoutMs = 10000) {
  return new Promise((resolve, reject) => {
    if (window.turnstile) return resolve();
    const start = Date.now();
    const timer = setInterval(() => {
      if (window.turnstile) {
        clearInterval(timer);
        resolve();
      } else if (Date.now() - start > timeoutMs) {
        clearInterval(timer);
        reject(new Error("Turnstile script failed to load"));
      }
    }, 100);
  });
}

// Renders the challenge inside `container` and resolves with a fresh
// single-use token. The widget is removed again once it resolves or fails.
export async function getTurnstileToken(action, container) {
  await waitForTurnstile();

  let widgetId;
  try {
    return await new Promise((resolve, reject) => {
      widgetId = window.turnstile.render(container, {
        sitekey: SITE_KEY,
        action,
        callback: resolve,
        "error-callback": () => reject(new Error("Turnstile challenge failed")),
      });
      if (widgetId === undefined) {
        reject(new Error("Turnstile render failed"));
      }
    });
  } finally {
    if (widgetId !== undefined) window.turnstile.remove(widgetId);
  }
}
